import type { ReactNode } from 'react';
import { fieldCls } from './styles';

export interface SelectOption {
  value: string;
  label: string;
}

interface Props {
  value: string;
  onChange: (v: string) => void;
  /** Provide either `options` or raw <option> children. */
  options?: SelectOption[];
  children?: ReactNode;
  /** Accessible label. */
  label: string;
  title?: string;
  /** Shrink to content width (toolbar selects like Sort); otherwise full width. */
  auto?: boolean;
  disabled?: boolean;
  className?: string;
}

/**
 * Styled native <select>. One rectangular shape everywhere — ends the
 * rect-vs-pill and uncapped-width drift between toolbars across modules.
 */
export default function FilterSelect({ value, onChange, options, children, label, title, auto, disabled, className = '' }: Props) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={label}
      title={title}
      disabled={disabled}
      className={`${fieldCls} min-h-[44px] cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 sm:min-h-0 ${auto ? 'w-auto' : 'w-full'} ${className}`}
    >
      {options ? options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>) : children}
    </select>
  );
}
